
export const activate_user = function(id) {
  // Check if this was an "Approve" action or re-activation from deactivated
  const activateButton = $('#activate_user_button');
  const buttonAction = activateButton.data('action');
  const wasApproveAction = buttonAction === 'approve';
  const wasReactivateAction = buttonAction === 'activate' && !activateButton.hasClass('disabled');
  
  // Always show the success message
  $('#address_card_toolbar').addClass('activated').removeClass('deactivated');
  
  if (wasApproveAction || wasReactivateAction) {
    activateButton.addClass('d-none');
    activateButton.prop('disabled', true);
    
    const activateDisabledButton = $('#activate_user_button_disabled');
    activateDisabledButton.removeClass('d-none');
    const deactivateDisabledButton = $('#deactivate_user_button_disabled');
    deactivateDisabledButton.addClass('d-none');
    
    const deactivateButton = $('#deactivate_user_button');
    deactivateButton.removeClass('d-none');
    deactivateButton.prop('disabled', false);
  }
};

export const fail_to_activate_user = function (errors) {
  var content = '';
  $.each(errors, function (key, value) {
    content = content + value + ' ';
  });
  var html = '<div class=\'popover_error\'>' + content + '</div>';
  $('#activate_user_button').popover({
    placement: 'top',
    trigger: 'manual',
    title: 'Approval Failed',
    content: html,
    html: true
  }).popover('show');
};

export const deactivate_user = function (id) {
  // Check if there's an Approve/Activate button to update
  const activateButton = $('#activate_user_button');
  const buttonAction = activateButton.data('action');
  const deactivateButton = $('#deactivate_user_button');
  deactivateButton.addClass('d-none');
  deactivateButton.prop('disabled', true);
  
  const deactivateDisabledButton = $('#deactivate_user_button_disabled');
  deactivateDisabledButton.removeClass('d-none');
  
  // Always show the success message
  $('#address_card_toolbar').addClass('deactivated').removeClass('activated');
  
  // If the activate button was "Approve" or "Activate" (disabled), enable it for re-activation
  if (buttonAction === 'approve' || (buttonAction === 'activate' && activateButton.hasClass('disabled'))) {
    const activateDisabledButton = $('#activate_user_button_disabled');
    activateDisabledButton.addClass('d-none');
    activateButton.removeClass('d-none');
    activateButton.prop('disabled', false);
  }
};

export const set_user_status = function(id) {
  $('#address_card_toolbar').addClass('status_updated');
};

window.activate_user = activate_user;
window.deactivate_user = deactivate_user;
window.fail_to_activate_user = fail_to_activate_user;
window.set_user_status = set_user_status;
